<template>
  <div v-if="isHeader">
    <span class="text-overflow text-clamp-2"
    v-tooltip="rowField.customField.label.toString().length > 24 ? rowField.customField.label : ''">{{ rowField.customField.label }}</span>
  </div>
  <div v-else-if="!isHeader">
    <mf-multi-select
      v-if="isEditable"
      v-model="cfValue"
      :options="customField.options"
      track-by="_id"
      label="displayValue"
      :multiple="false"
      :allow-empty="false"
      :closeOnSelect="true"
      :placeholder="customField.placeholder"
      @update:modelValue="() => updateCfValue()">
    </mf-multi-select>
    <span v-else>
      {{ getVal() }}
    </span>
  </div>
</template>


<script>

import { onBeforeMount, reactive, toRefs, inject, computed } from 'vue';
import { cloneDeep, find, isEmpty, isFunction, isString } from 'lodash';

export default {
  name: 'Dropdown',
  props: {
    rowField: {
      type: Object,
      default: () => ({}),
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
    isEditing: {
      type: Boolean,
    },
    emitOrderSave: {
      type: Boolean,
      default: false,
    },
    isHeader: {
      type: Boolean,
    },
  },
  setup(props, { emit }) {
    const shippingEvents = inject('saveShipping');
    const state = reactive({
      cfValue: null,
      customField: {},
    });

    onBeforeMount(() => {
      if (isEmpty(props.rowData.customFields) || !find(props.rowData.customFields, { _id: props.rowField.customField._id })) {
        if(!props.rowData.customFields) {
          props.rowData.customFields = [];
        }
        props.rowData.customFields.push(cloneDeep(props.rowField.customField));
      }
      state.customField = cloneDeep(props.rowField.customField);
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        if (isString(itemField.value)) {
          state.cfValue = find(state.customField.options, { displayValue: itemField.value });
        } else {
          state.cfValue = find(state.customField.options, (opts) => opts?._id === itemField?.value?._id);
        }
      }
    });

    const updateCfValue = async () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField) {
        itemField.value = state.cfValue;
      }
      if (props.emitOrderSave && !isEmpty(shippingEvents) && isFunction(shippingEvents.save)) {
        await shippingEvents.save(props.rowData);
      }
    };

    const isEditable = computed(() => {
      if (props.rowField.isEditable) return true;
      if (props.rowField.noEdit) return false;
      return props.isEditing;
    })

    const getVal = () => {
      const itemField = find(props.rowData.customFields, { _id: state.customField._id });
      if (itemField && itemField.value) {
        if (isString(itemField.value)) {
          state.cfValue = find(state.customField.options, { displayValue: itemField.value });
        } else {
          state.cfValue = find(state.customField.options, (opts) => opts?._id === itemField?.value?._id);
        }
        return state.cfValue.displayValue;
      }
      return 'No option selected'
    };

    return {
      ...toRefs(state),
      updateCfValue,
      isEditable,
      getVal
    }
  }
}

</script>